module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "myNav",
    staticClass: "header"
  }, [_c('div', {
    ref: "myNav",
    staticClass: "header-content clear"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "site-nav fl"
  }, [_c('ul', {
    staticClass: "nav-list fl clear"
  }, [_c('li', {
    ref: "decorate",
    staticClass: "decorate",
    style: ('left:' + _vm.decorateLeft + 'px')
  }), _vm._v(" "), _vm._l((_vm.routeArr), function(item, index) {
    return _c('li', {
      staticClass: "nav-item",
      class: {
        'link': _vm.pathName == item.detailPath
      },
      on: {
        "mouseenter": function($event) {
          return _vm.changeLeft(index)
        },
        "mouseleave": function($event) {
          return _vm.backLeft()
        }
      }
    }, [_c('a', {
      key: item.id,
      staticClass: "route-link",
      class: {
        'activityColor': _vm.formName === item.listPath || _vm.formName === item.detailPath
      },
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.name))])])
  })], 2), _vm._v(" "), _c('v-login', {
    staticClass: "fl",
    attrs: {
      "loginCssStatus": _vm.loginCssStatus
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo fl"
  }, [_c('a', {
    attrs: {
      "href": "http://breadoffer.com"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/logo3.svg"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31e5e3b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 207
// module chunks = 19